import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { baseQuery, endpoints } from 'utils/api/endpoints';
import { State } from './types';

export const initialState: State = {
  uploadedFile: null,
};

const slice = createSlice({
  name: 'bannerManagement',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'bannerManagementApi',
  baseQuery,
  tagTypes: ['bannerList'],
  endpoints: builder => ({
    getBanners: builder.query<any, any>({
      query: () => ({
        url: endpoints.BANNERS,
        method: 'GET',
      }),
      providesTags: ['bannerList'],
    }),
    addBanner: builder.mutation<any, any>({
      query: body => ({
        url: endpoints.BANNERS,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['bannerList'],
    }),
    updateBanner: builder.mutation<any, any>({
      query: body => ({
        url: endpoints.BANNERS + '/' + body.id,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['bannerList'],
    }),
    deleteBanner: builder.mutation<any, any>({
      query: id => ({
        url: endpoints.BANNERS + '/' + id,
        method: 'DELETE',
      }),
      invalidatesTags: ['bannerList'],
    }),
    updateBannerStatus: builder.mutation<any, any>({
      query: id => ({
        url: endpoints.BANNERS + '/' + id + '/toggle-status',
        method: 'PATCH',
      }),
      invalidatesTags: ['bannerList'],
    }),
    getBannerById: builder.query<any, any>({
      query: id => ({
        url: endpoints.BANNERS + '/get-banner-by-id/' + id,
        method: 'GET',
      }),
    }),
  }),
});

export const { actions: BannerManagementAction } = slice;

export const useBannerManagementSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    useGetBannersQuery: api.useLazyGetBannersQuery,
    useAddBannerMutation: api.useAddBannerMutation,
    useUpdateBannerMutation: api.useUpdateBannerMutation,
    useDeleteBannerMutation: api.useDeleteBannerMutation,
    useUpdateBannerStatusMutation: api.useUpdateBannerStatusMutation,
    useGetBannerByIdQuery: api.useLazyGetBannerByIdQuery,
    actions: BannerManagementAction,
  };
};
